module.exports = __webpack_public_path__ + "63e620dc5053e811d99f7bff1f2b0cf1.png";